import {Boot} from '@/project'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

declare module 'vue/types/vue' {
  interface Vue {
    readonly $sentry: any
  }
}

const boot: Boot = ({Vue}) => {
  if(process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.VUE_APP_SENTRY_DSN,
      integrations: [new Integrations.Vue({Vue, attachProps: true})],
      ignoreErrors: [
        /code 401$/,
        /^Request aborted$/,
        /^Network Error$/,
        /^AbortError$/,
      ],
      environment: process.env.NODE_ENV,
    })
    Vue.prototype.$sentry = Sentry
  }
}

export default boot
